/**
 * The COMING SOON pill used by disabled inventory rows and the placeholder
 * sections on the Study/Practice hubs (feature 023, FR-010).
 *
 * Plain text, not colour-only, so the state survives greyscale and screen
 * readers announce it.
 */
export function ComingSoonChip({ className = '' }: { className?: string }) {
  return (
    <span
      className={
        // text-ink-soft (#5c584a) rather than the reference's #6b6350: at 10.5px
        // the lighter grey sits at 4.7:1 on this chip, with no margin for the
        // surfaces it also appears on. ink-soft clears 6:1 everywhere.
        'rounded-full bg-[#eee5cd] px-2.5 py-1 text-[10.5px] font-extrabold tracking-[0.1em] text-ink-soft ' +
        className
      }
      data-testid="coming-soon-chip"
    >
      COMING SOON
    </span>
  );
}
